import API from 'services/api';

type TUnitOccupancyCreate = {
  dateFrom: string;
  dateTo: string;
  isConfirmed: boolean;
  renterOptionDate: string;
  note: string;
  guest: {
    guestId: string;
    name: string;
    countryId: number;
    phone: string;
    email: string;
    note: string;
    agencyName: string;
  };
  unitId: string;
};

type TUnitOccupancyUpdate = {
  unitOccupancyId: string;
  payload: TUnitOccupancyCreate;
};

export interface IUnitOccupancyResponse {
  unitOccupancyId: string;
  status: number;
  propertyId: string;
  propertyName: string;
  unitId: string;
  unitCode: string;
  unitName: string;
  dateFrom: string;
  dateTo: string;
  isConfirmed: boolean;
  renterOptionDate: string | null;
  numberOfPeople: number;
  guest: { name: string } | null;
  errors: unknown | null;
}

export const createUnitOccupancy = (payload: TUnitOccupancyCreate) =>
  API.post('/api/accommodation/unit-occupancy', payload);

export const updateUnitOccupancy = ({ unitOccupancyId, payload }: TUnitOccupancyUpdate) =>
  API.put(`/api/accommodation/unit-occupancy/${unitOccupancyId}`, payload);

export const deleteUnitOccupancy = (unitOccupancyId: string) =>
  API.delete(`/api/accommodation/occupancies/${unitOccupancyId}`);
